import { render, staticRenderFns } from "./OrderDetailsDesktopView.vue?vue&type=template&id=9833dd86&"
import script from "./OrderDetailsDesktopView.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsDesktopView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports